<template>
  <el-config-provider :locale="zhCn">
    <div class="finance_box" ref="myElementRef">
    <div ref="searchBox" v-if="state.flng">
      <hc-search :data="serchData" @serch="getSarch($event)" @getadd="getadd($event)" />
    </div>
    <!-- 表格 -->
    <div class="table_box">
      <hc-table 
        :tableData="tableData" 
        :column="state.tableHeader" 
        :offsetHeight="state.offsetHeight"
        :maxPage="maxPage"
        @pageChange="pageChange($event)"
        @limitChange="limitChange($event)"
      >
        <template #operation="scope">
          <div class="btn_box_det">
            <el-button size="small" type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" link @click="del(scope.row)">删除</el-button>
          </div>
        </template>
      </hc-table>
    </div>
    
    <el-dialog align-center v-model="dialogVisible" title="项目信息" width="550" draggable>
      <div class="userAdd_man">
        <el-form label-width="auto" :model="formLabelAlign" class="userFrom" ref="formRef" :rules="rules">
          <el-form-item label="项目编码" prop="project_code">
            <el-input v-model="formLabelAlign.project_code" placeholder="请输入项目编码" :disabled="formLabelAlign.id > 0" />
          </el-form-item>
          <el-form-item label="项目名称" prop="project_name">
            <el-input v-model="formLabelAlign.project_name" placeholder="请输入项目名称" />
          </el-form-item>
          <el-form-item label="所属城市" prop="city">
            <el-cascader
              v-model="selectedCityArray"
              :options="cityOptions"
              placeholder="请选择所属城市"
              style="width: 100%;"
              filterable
              clearable
              @change="handleCityChange"
            />
          </el-form-item>
          <el-form-item label="项目地址" prop="address">
            <el-input v-model="formLabelAlign.address" placeholder="请输入项目地址" />
          </el-form-item>
          <el-form-item label="项目总面积(㎡)" prop="total_area">
            <el-input-number v-model="formLabelAlign.total_area" :precision="2" :step="100" :min="0" placeholder="请输入项目总面积" style="width: 100%;" />
          </el-form-item>
        </el-form>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="subimt($refs.formRef)">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
  </el-config-provider>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import { 
  ProjectAdd, 
  ProjectList, 
  ProjectDel 
} from '@/api/project.js';

const myElementRef = ref();
const searchBox = ref();
let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const dialogVisible = ref(false);
const selectedCityArray = ref([]);

const cityOptions = [
  { value: '北京市', label: '北京市' },
  { value: '上海市', label: '上海市' },
  { value: '天津市', label: '天津市' },
  { value: '重庆市', label: '重庆市' },
  {
    value: '江苏省',
    label: '江苏省',
    children: [
      { value: '南京市', label: '南京市' },
      { value: '无锡市', label: '无锡市' },
      { value: '徐州市', label: '徐州市' },
      { value: '常州市', label: '常州市' },
      { value: '苏州市', label: '苏州市' },
      { value: '南通市', label: '南通市' },
      { value: '连云港市', label: '连云港市' },
      { value: '淮安市', label: '淮安市' },
      { value: '盐城市', label: '盐城市' },
      { value: '扬州市', label: '扬州市' },
      { value: '镇江市', label: '镇江市' },
      { value: '泰州市', label: '泰州市' },
      { value: '宿迁市', label: '宿迁市' }
    ]
  },
  {
    value: '浙江省',
    label: '浙江省',
    children: [
      { value: '杭州市', label: '杭州市' },
      { value: '宁波市', label: '宁波市' },
      { value: '温州市', label: '温州市' },
      { value: '嘉兴市', label: '嘉兴市' },
      { value: '湖州市', label: '湖州市' },
      { value: '绍兴市', label: '绍兴市' },
      { value: '金华市', label: '金华市' },
      { value: '衢州市', label: '衢州市' },
      { value: '舟山市', label: '舟山市' },
      { value: '台州市', label: '台州市' },
      { value: '丽水市', label: '丽水市' }
    ]
  },
  {
    value: '广东省',
    label: '广东省',
    children: [
      { value: '广州市', label: '广州市' },
      { value: '深圳市', label: '深圳市' },
      { value: '珠海市', label: '珠海市' },
      { value: '汕头市', label: '汕头市' },
      { value: '佛山市', label: '佛山市' },
      { value: '韶关市', label: '韶关市' },
      { value: '湛江市', label: '湛江市' },
      { value: '肇庆市', label: '肇庆市' },
      { value: '江门市', label: '江门市' },
      { value: '茂名市', label: '茂名市' },
      { value: '惠州市', label: '惠州市' },
      { value: '梅州市', label: '梅州市' },
      { value: '汕尾市', label: '汕尾市' },
      { value: '河源市', label: '河源市' },
      { value: '阳江市', label: '阳江市' },
      { value: '清远市', label: '清远市' },
      { value: '东莞市', label: '东莞市' },
      { value: '中山市', label: '中山市' },
      { value: '潮州市', label: '潮州市' },
      { value: '揭阳市', label: '揭阳市' },
      { value: '云浮市', label: '云浮市' }
    ]
  },
  {
    value: '四川省',
    label: '四川省',
    children: [
      { value: '成都市', label: '成都市' },
      { value: '自贡市', label: '自贡市' },
      { value: '攀枝花市', label: '攀枝花市' },
      { value: '泸州市', label: '泸州市' },
      { value: '德阳市', label: '德阳市' },
      { value: '绵阳市', label: '绵阳市' },
      { value: '广元市', label: '广元市' },
      { value: '遂宁市', label: '遂宁市' },
      { value: '内江市', label: '内江市' },
      { value: '乐山市', label: '乐山市' },
      { value: '南充市', label: '南充市' },
      { value: '眉山市', label: '眉山市' },
      { value: '宜宾市', label: '宜宾市' },
      { value: '广安市', label: '广安市' },
      { value: '达州市', label: '达州市' },
      { value: '雅安市', label: '雅安市' },
      { value: '巴中市', label: '巴中市' },
      { value: '资阳市', label: '资阳市' }
    ]
  },
  {
    value: '山东省',
    label: '山东省',
    children: [
      { value: '济南市', label: '济南市' },
      { value: '青岛市', label: '青岛市' },
      { value: '淄博市', label: '淄博市' },
      { value: '枣庄市', label: '枣庄市' },
      { value: '东营市', label: '东营市' },
      { value: '烟台市', label: '烟台市' },
      { value: '潍坊市', label: '潍坊市' },
      { value: '济宁市', label: '济宁市' },
      { value: '泰安市', label: '泰安市' },
      { value: '威海市', label: '威海市' },
      { value: '日照市', label: '日照市' },
      { value: '临沂市', label: '临沂市' },
      { value: '德州市', label: '德州市' },
      { value: '聊城市', label: '聊城市' },
      { value: '滨州市', label: '滨州市' },
      { value: '菏泽市', label: '菏泽市' }
    ]
  },
  {
    value: '福建省',
    label: '福建省',
    children: [
      { value: '福州市', label: '福州市' },
      { value: '厦门市', label: '厦门市' },
      { value: '莆田市', label: '莆田市' },
      { value: '三明市', label: '三明市' },
      { value: '泉州市', label: '泉州市' },
      { value: '漳州市', label: '漳州市' },
      { value: '宁德市', label: '宁德市' }
    ]
  },
  {
    value: '湖北省',
    label: '湖北省',
    children: [
      { value: '武汉市', label: '武汉市' },
      { value: '黄石市', label: '黄石市' },
      { value: '十堰市', label: '十堰市' },
      { value: '宜昌市', label: '宜昌市' },
      { value: '襄阳市', label: '襄阳市' },
      { value: '荆州市', label: '荆州市' },
      { value: '黄冈市', label: '黄冈市' }
    ]
  },
  {
    value: '湖南省',
    label: '湖南省',
    children: [
      { value: '长沙市', label: '长沙市' },
      { value: '株洲市', label: '株洲市' },
      { value: '湘潭市', label: '湘潭市' },
      { value: '衡阳市', label: '衡阳市' },
      { value: '岳阳市', label: '岳阳市' },
      { value: '常德市', label: '常德市' }
    ]
  }
];

const handleCityChange = (value) => {
  if (value && value.length > 0) {
    formLabelAlign.city = value.join('/');
  } else {
    formLabelAlign.city = '';
  }
};

const rules = reactive({
  project_code: [
    { required: true, message: "项目编码不能为空", trigger: "blur" },
  ],
  project_name: [
    { required: true, message: "项目名称不能为空", trigger: "blur" },
  ],
});

const tableData = ref([]);

const serchData = reactive([
  {
    label: "项目名称",
    type: "input",
    value: "",
  },
  {
    label: "",
    type: "add",
    value: true
  }
]);

const state = reactive({
  title: "",
  column: [
    {
      type: "index",
      show: true,
      label: "序号",
      width: 80,
    },
    {
      prop: "project_code",
      show: true,
      label: "项目编码",
      width: 150,
    },
    {
      prop: "project_name",
      show: true,
      label: "项目名称",
      width: 250,
    },
    {
      prop: "city",
      show: true,
      label: "所属城市",
      width: 150,
    },
    {
      prop: "address",
      show: true,
      label: "项目地址",
      width: 350,
    },
    {
      prop: "total_area",
      show: true,
      label: "项目总面积(㎡)",
      width: 150,
    },
    {
      prop: "created_by",
      show: true,
      label: "创建人",
      width: 150,
    },
    {
      prop: "created_at",
      show: true,
      label: "创建时间",
      width: 200,
    },
    {
      prop: "operation",
      show: true,
      label: "操作",
      width: 140, 
    },
  ],
  flng: true,
  offsetHeight: 0,
  tableHeader: [],
});

const formLabelAlign = reactive({
  id: 0,
  project_code: "",
  project_name: "",
  city: "",
  address: "",
  total_area: undefined
});

// 动态改变表头
const change = (item) => {
  tableHeaderFn();
};

onMounted(() => {
  try {
    nextTick(() => {
      offHeighths();
    });
    window.onresize = () => {
      nextTick(() => {
        offHeighths();
      });
    };
    tableHeaderFn();
  } catch { }
  getList();
});

const offHeighths = () => {
  if (myElementRef.value) {
    state.offsetHeight =
      myElementRef.value?.offsetHeight - 130 - searchBox.value?.offsetHeight;
  }
};

onUnmounted(() => {
  window.onresize = null;
});

const getadd = () => {
  Object.assign(formLabelAlign, {
    id: 0,
    project_code: "",
    project_name: "",
    city: "",
    address: "",
    total_area: undefined
  });
  selectedCityArray.value = [];
  dialogVisible.value = true;
};

const edit = async (row) => {
  Object.assign(formLabelAlign, {
    id: row.id,
    project_code: row.project_code,
    project_name: row.project_name,
    city: row.city || "",
    address: row.address || "",
    total_area: row.total_area
  });
  if (row.city) {
    selectedCityArray.value = row.city.split('/');
  } else {
    selectedCityArray.value = [];
  }
  dialogVisible.value = true;
};

// 查询
const getSarch = (data) => {
  page.value = 1;
  getList();
};

const pageChange = (currentPage) => {
  page.value = currentPage;
  getList();
};

const limitChange = (currentLimit) => {
  page.value = 1;
  limit.value = currentLimit;
  getList();
};

// 表头筛选
const tableHeaderFn = () => {
  state.tableHeader = state.column.filter((v) => {
    if (v.show) {
      return v.show == true;
    } else {
      v.show = false;
    }
  });
};

const getList = async () => {
  const res = await ProjectList({
    current: page.value,
    size: limit.value,
    projectName: serchData[0].value
  });
  if (res.code === 200 && res.data) {
    tableData.value = res.data.records || [];
    maxPage.value = res.data.total || 0;
  } else {
    tableData.value = [];
    maxPage.value = 0;
  }
};

const subimt = async (formEl) => {
  if (!formEl) return;

  await formEl.validate(async (valid) => {
    if (valid) {
      try {
        const data = { ...formLabelAlign };
        const res = await ProjectAdd(data);
        if (res.code === 200) {
          dialogVisible.value = false;
          ElMessage.success('保存成功');
          getList();
        } else {
          ElMessage.error(res.msg || '保存失败');
        }
      } catch (error) {
        ElMessage.error('保存失败，请重试');
      }
    } else {
      ElMessage.warning('请填写完整的信息');
    }
  });
};

const del = (row) => {
  ElMessageBox.confirm('确认要删除该项目信息吗？', '删除提醒', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    getDel(row);
  }).catch(() => {});
};

const getDel = async (row) => {
  const res = await ProjectDel({
    id: row.id
  });
  if (res.code === 200) {
    ElMessage.success('删除成功');
    getList();
  } else {
    ElMessage.error(res.msg || '删除失败');
  }
};
</script>

<style lang="less" scoped>
.finance_box {
  flex: 1;
  overflow: auto;
  background-color: #fff;
  border-radius: 6px;
  padding: 10px;
  margin-right: 10px;
}

.btn_box {
  height: 40px;
  display: flex;
}

.table_box {
  width: 100%;
  /deep/ .el-image {
    cursor: pointer;
  }
}

/deep/.el-button-group .el-button--primary:first-child {
  background-color: #1e6aed;
  border: none;
}

.serBtn {
  margin-left: 10px;
  background-color: #f0f0f0;
  color: #000;
  border: none;
}

.serBtn:hover {
  background-color: #f0f0f0;
  color: #000;
}

.opBtn {
  margin: 0 !important;
}

.opBtn:hover {
  color: #e6a755;
}

.userAdd_man {
  min-height: 200px;
  overflow: auto;
  padding: 0 30px;
}

.userFrom {
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr;
}

.el-form-item {
  margin-bottom: 0;
}
</style>
